// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramSingleFamilyWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingAdproductDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Options = UseQueryOptions<
  AccountViewListingAdproductDto,
  unknown,
  AccountViewListingAdproductDto,
  Array<string | AdvertisingParams>
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_GetKey = (getParams: AdvertisingParams) => [
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path,
  getParams,
];

/**
 * Get single family customer account view property listing advertising
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  options: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising(getParams),
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingsDto,
  unknown,
  AccountViewListingsDto,
  Array<string | ListParams>
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_GetKey = (getParams: ListParams) => [
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path,
  getParams,
];

/**
 * Get single family customer account view property list
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_list = (
  getParams: ListParams,
  options: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_list(getParams),
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_list.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  Array<string | OptionsParams>
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_GetKey = (getParams: OptionsParams) => [
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path,
  getParams,
];

/**
 * Get single family customer account view property listing options
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_options = (
  getParams: OptionsParams,
  options: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_options(getParams),
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_options.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Options = UseQueryOptions<
  AccountViewListingProspectsDto,
  unknown,
  AccountViewListingProspectsDto,
  Array<string | ProspectsParams>
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_GetKey = (getParams: ProspectsParams) => [
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path,
  getParams,
];

/**
 * Get single family customer account view property prospects
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  options: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects(getParams),
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Options = UseQueryOptions<
  AccountViewListingSourcesDto,
  unknown,
  AccountViewListingSourcesDto,
  Array<string | SourcesParams>
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_GetKey = (getParams: SourcesParams) => [
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path,
  getParams,
];

/**
 * Get single family customer account view property listing sources
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  options: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources(getParams),
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_sources.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Options = UseQueryOptions<
  AccountViewListingStatusOverviewDto,
  unknown,
  AccountViewListingStatusOverviewDto,
  Array<string | StatusParams>
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_GetKey = (getParams: StatusParams) => [
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path,
  getParams,
];

/**
 * Get single family customer account view property listing status
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_status = (
  getParams: StatusParams,
  options: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_status(getParams),
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_status.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_GetKey;
